import { mediaQueries, style } from '@do/walrus';
import styled from 'styled-components';

const NewWrapper = styled.div`
  padding: 0;

  ${mediaQueries.medium} {
    padding: ${style.vars.whitespace.small} ${style.vars.whitespace.regular};
  }
`;

export default NewWrapper;
